import { useState, useEffect } from "react";
import { Star, Quote } from "lucide-react";
import axios from "axios";

const API = "/api";

export const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section className="py-20 sm:py-28 bg-slate-50" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-left max-w-xl mb-16">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wide">Testimonianze</span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight"
            style={{ fontFamily: "Outfit, sans-serif" }} data-testid="testimonials-title">
            Cosa dicono i nostri<br />clienti
          </h2>
          <p className="mt-4 text-slate-500 text-base sm:text-lg">
            Migliaia di italiani hanno gia scelto il fotovoltaico grazie a noi.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((t, i) => (
            <div key={t.id || i} className="testimonial-card bg-white rounded-2xl border border-slate-100 p-6"
              data-testid={`testimonial-card-${i}`}>
              <Quote className="w-8 h-8 text-emerald-200 mb-4" strokeWidth={1.5} />
              <p className="text-sm text-slate-600 leading-relaxed mb-5">"{t.text}"</p>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: t.rating || 5 }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-semibold text-sm text-slate-900">{t.name}</div>
                  <div className="text-xs text-slate-400">{t.location}</div>
                </div>
                {t.savings && (
                  <div className="text-right">
                    <div className="text-sm font-bold text-emerald-600">{t.savings}</div>
                    <div className="text-xs text-slate-400">risparmio</div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
